exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-panel[data-v-1626b60c]{margin:1rem auto;max-width:70rem}.info-panel.reverse .card-body>.row[data-v-1626b60c]{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.info-panel.link-panel[data-v-1626b60c]{cursor:pointer}.info-panel.link-panel[data-v-1626b60c]:hover{-webkit-box-shadow:0 .1rem .6rem 0 rgba(0,0,0,.1);box-shadow:0 .1rem .6rem 0 rgba(0,0,0,.1)}", ""]);

// exports
